<template>
  <div v-if="ready">
    <a
      v-for="l in otherLocales"
      :key="l"
      :href="nextRoute(l)"
      class="px-4 py-2 hover:bg-menu-hover block"
      v-text="i18n[l].nextRoute"
    />
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      locales: ["en", "fr"],
    };
  },
  methods: {
    nextRoute(locale) {
      return this.$route.path.replace(
        "/" + this.locale + "/",
        "/" + locale + "/"
      );
    },
  },
  computed: {
    ready() {
      return this.$store.state.app.i18n.components;
    },
    i18n() {
      return this.$store.state.app.i18n.components.localeSwitcher;
    },
    locale() {
      return this.$route.params.locale;
    },
    otherLocales() {
      return this.locales.filter((l) => l != this.locale);
    },
  },
};
</script>
